import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useEffect, useState } from 'react';

import { Button } from '../../components/ui/Button.jsx';
import { Modal } from '../../components/ui/Modal.jsx';
import { useTranslation } from '../../i18n/useTranslation.js';
import { financeApi } from '../../services/financeApi.js';

const empty = () => ({ code: '', name: '', description: '' });

export function ProfitCenterModal({ open, onClose }) {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const [form, setForm] = useState(empty);
  const [error, setError] = useState(null);

  useEffect(() => { if (open) { setForm(empty()); setError(null); } }, [open]);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const save = useMutation({
    mutationFn: (body) => financeApi.createProfitCenter(body),
    onSuccess: () => { queryClient.invalidateQueries({ queryKey: ['finance', 'profit-centers'] }); onClose(); },
    onError: (err) => setError(err?.message || t('common.loadError')),
  });

  function submit(e) {
    e.preventDefault();
    setError(null);
    if (!form.code.trim() || !form.name.trim()) { setError(t('pc.error.required')); return; }
    save.mutate({ code: form.code.trim(), name: form.name.trim(), description: form.description || null });
  }

  return (
    <Modal open={open} onClose={onClose} title={t('pc.modal.title')}
      footer={<><Button variant="ghost" onClick={onClose}>{t('common.cancel')}</Button>
        <Button variant="primary" onClick={submit} disabled={save.isPending}>{save.isPending ? `${t('common.save')}…` : t('common.save')}</Button></>}>
      <form onSubmit={submit} className="form-stack">
        <div className="field-row">
          <label className="field" style={{ maxWidth: 160 }}><span className="field-label">{t('pc.col.code')}</span>
            <input className="input mono" value={form.code} onChange={set('code')} required />
          </label>
          <label className="field"><span className="field-label">{t('pc.col.name')}</span>
            <input className="input" value={form.name} onChange={set('name')} required />
          </label>
        </div>
        <label className="field"><span className="field-label">{t('pc.field.description')}</span>
          <input className="input" value={form.description} onChange={set('description')} />
        </label>
        {error && <div className="alert danger">{error}</div>}
      </form>
    </Modal>
  );
}
